import classNames from "classnames"
import React, { Children } from "react"
import SwiperCore, { Autoplay } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import "./styles.css"

type Props = {
  children: React.ReactNode
  className?: string
  slideClassName?: string
  autoplay?: boolean
}

SwiperCore.use([Autoplay])

/**
 * @todo We're using this for TestimonialSwiper and SocialProofing.
 * We should refactor this to be more generic.
 */
const SocialProofingSlider = ({
  children,
  className,
  slideClassName,
  autoplay,
}: Props) => {
  return (
    <Swiper
      id="social-proofing"
      spaceBetween={20}
      slidesOffsetBefore={20}
      slidesOffsetAfter={20}
      slidesPerView="auto"
      loop={true}
      autoplay={
        autoplay
          ? {
              delay: 0,
              disableOnInteraction: false,
            }
          : false
      }
      freeMode
      grabCursor
      watchOverflow
      breakpoints={{
        900: {
          spaceBetween: 24,
        },
        1200: {
          spaceBetween: 32,
        },
      }}
      speed={25000}
      className={classNames("overflow-visible", className)}
    >
      {Children.map(children, (child, index) => (
        <SwiperSlide
          key={`swiper-slide-${index}`}
          className={classNames(
            "grid h-auto w-[375px] last:mr-[calc(100vw-5.33vw-375px)]",
            slideClassName
          )}
        >
          {child}
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default SocialProofingSlider
